import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Col, Row, Card, Form, Button, Spinner, Container, Navbar, Nav, InputGroup, Alert} from 'react-bootstrap';
import Swal from 'sweetalert2';
import ReactMarkdown from 'react-markdown';
import RenderizarProduto from '../components/Utils/RenderizarProduto';
import RenderizarFoto from '../components/Utils/RenderizarFoto';
import ImageCropper from '../components/Utils/ImageCropper';
import PhoneInput from '../components/Input/PhoneInput'
import { useCrud } from '../hooks/useCrud';
import AOS from "aos";
import 'aos/dist/aos.css';
import BarraDeProgresso from '../components/Utils/BarraDeProgresso';

import Produtos from '../components/Catalogo/Produtos';
import SelecionarProduto from '../components/Catalogo/SelecionarProduto';
import CarrinhoPedido from '../components/Catalogo/CarrinhoPedido';
import Endereco from '../components/Catalogo/Endereco';
import Feedback from '../components/Catalogo/Feedback';
import { useProvider, Toast } from '../context/MenuProvider';

import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");

const Catalogo = () => {
  const [comprovante, setComprovante] = useState(null);
  const {
    crud,
    auth,
    loja,
    site,
    buscarDadosPorId,
  } = useProvider();
  const { get, loading } = crud || {};
  const [isCarregado, setIsCarregado] = useState(false);
  const { slug } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  useEffect(() => {
    // Inicialize o AOS para as animações, caso esteja usando isso
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
      mirror: false
    });
  }, []);
  
  const checarLogin = (value) =>{
    switch (value) {
      case 'perfil':
        return 'login';
      case 'meus-pedidos':
        return 'comprovante';
    }
    return value;
  }
  const pagina = checarLogin(queryParams.get('p')?.toLowerCase());
  
  useEffect(()=>{
    if(!comprovante){
      const t = queryParams.get('t')?.toLowerCase();
      const i = queryParams.get('i')?.toLowerCase();
      //alert(`setComprovante\n${JSON.stringify(loja?.url||slug)}`)
      if(t && i){
        setComprovante({
          empresa:loja?.url||slug,
          token:t,
          id:i
        })
      }
    }
  }, [setComprovante])
  
  useEffect(()=>{
    const gravarComprovante = async()=>{
      try{
        //alert(`comprovante\n${JSON.stringify(comprovante)}`)
        // await storage.remover('comprovante');
        // await storage.adicionar('comprovante', comprovante);
      }catch(err){
        
      }
    }
    if(comprovante){
      gravarComprovante();
    }
  },[comprovante])
  
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    }
  });
  
  if(!loja){
    return (
        <>
          <Row className="d-flex align-items-center justify-content-center" data-aos="fade-up">
            <Col className="text-center py-5">
              <div className="fs-4">
                Empresa não encontrada
              </div>
              <div className="fs-1">
                404
              </div>
              <div className="text-muted">
                Acesse com o app ou link direto da empresa que você deseja acessar o app
              </div>
              <div className="py-5">
                <div>
                  Você tem um negócio e procura um sistema para gerenciar?
                </div>
                <div>
                  Confira esse App, talvez você goste...
                </div>
                <Link to="/instalar-app" className="mt-4 btn btn-secondary">Conhecer App</Link>
              </div>
            </Col>
          </Row>
        </>
    )
  }
  
  return (
    <>
      {!pagina && (
        <>
          <Row data-aos="fade-up">
            <Col xs={7} md={3} className="mx-auto">
              <RenderizarFoto src={`https://${site?.domain}${loja?.logomarca}`} className="img-fluid" alt="" />
            </Col>
            <Col xs={12} md={12} className="text-center">
              <div className="fs-4">{loja?.nome_da_loja}</div>
              <div className="text-muted">{loja?.descricao}</div>
            </Col>
          </Row>
          {loja?.configuracoes?.url_ecomerce && (
            <div className="py-2 text-center" data-aos="fade-up">
                <Button variant="dark" onClick={()=>window.open(loja?.configuracoes?.url_ecomerce)} className="mt-4 w-100" disabled={loading}>
                  Acesse meu eCommerce
                </Button>
            </div>
          )}
          <Produtos crud={crud}  empresa={loja} Toast={Toast} queryParams={queryParams}/> 
        </>
      )}
      {pagina === "adicionar-produto" && <SelecionarProduto crud={crud}  empresa={loja} Toast={Toast} queryParams={queryParams}/> }
      {pagina === "meus-pedidos" && <MeusPedidos crud={crud}  empresa={loja} Toast={Toast} queryParams={queryParams}/> }
      {pagina === "checkout" && <CarrinhoPedido crud={crud}  empresa={loja} Toast={Toast} queryParams={queryParams}/> }
      {pagina === "endereco" && <Endereco crud={crud}  empresa={loja} Toast={Toast} queryParams={queryParams}/> }
      {pagina === "contato" && <Contato crud={crud}  empresa={loja} Toast={Toast} queryParams={queryParams}/> }
      {pagina === "perfil" && <PerfilCliente crud={crud}  empresa={loja} Toast={Toast} queryParams={queryParams}/> }
      {pagina === "login" && <LoginCatalogo crud={crud}  empresa={loja} Toast={Toast} queryParams={queryParams}/> }
      {pagina === "comprovante" && <Comprovante crud={crud}  empresa={loja} Toast={Toast} queryParams={queryParams}/> }
      {pagina === "feedback" && <Feedback crud={crud}  empresa={loja} Toast={Toast} queryParams={queryParams}/> }
    </>
  )
}


const MeusPedidos = ({crud, Toast, empresa, queryParams}) => {
    const navigate = useNavigate();
    const { get, loading } = crud;
    const [extrato, setExtrato] = useState(null);
    const [vendas, setVendas] = useState([]);

    useEffect(() => {
      // Inicialize o AOS para as animações, caso esteja usando isso
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
        mirror: false
      });
    }, []);
    
    const buscarExtrato =async()=>{
        try{
          const response = await get([
            `/gvendas/vendas/?ordering=-data_da_venda&filtros=id,data_da_venda,total,token&expand=cliente&limit=5`,
            `/gvendas/relatorios/0/historico-de-compras/`
          ], 'pagina');
          if(response && response.length){
            setVendas(response[0].results);
            setExtrato(response[1]);
          }
        }catch(err){
          //alert(JSON.stringify(err.response))
        }
    }
    
    useEffect(()=>{
      buscarExtrato();
    }, [])
    
    const getImgStatus = (x) => {
      if(x.total_aberto <= 0){
        return '/images/img_pago.jpg';
      }else if(x.total_aberto > 0 && x.total_pago > 0){
        return '/images/img_parcial.jpg';
      }else{
        return '/images/img_fiado.jpg';
      }
    }
    
    
    return (
        <>
          <div className="mt-3" data-aos="fade-up">
                <div className="list-group mt-3">
                    <>
                      <div className="border-dashed-bottom mb-2">Últimas Compras</div>
                      {vendas?.map((item, index) => (
                            <div className="mb-1">
                              <Row>
                                  <Col><Button variant="outline-secondary" onClick={()=>navigate(`?p=comprovante&i=${item.id}&t=${item.cliente.token}`)} className="btn-sm mb-1">{item.data_da_venda}</Button></Col>
                                  <Col xs="auto" className="pt-1">{parseFloat(item.total || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</Col>
                              </Row>
                              <Col xs={12} className="border-bottom"></Col>
                            </div>
                        ))}
                      <div className="border-dashed-top my-2">
                        <Row>
                                <Col>Total em aberto</Col>
                                <Col xs="auto">
                                  <b>
                                    {parseFloat(extrato?.total_divida || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                                  </b>
                                </Col>
                              </Row>
                      </div>
                        
                      <div className="border-dashed-bottom mt-5 mb-2">Extrato de conta</div>
                        {extrato?.historico?.map((grupo, index) => (
                              <div className="mb-3">
                                {grupo.lista.map((item, index)=>(
                                  <>
                                    <Row>
                                      <Col>{dayjs(grupo.data).format("DD/MM/YYYY")} {item.tipo==="compra"?"Compra":"Pagamento"}</Col>
                                      <Col xs="auto">{item.tipo==="compra"?"+":"-"}{parseFloat(item.valor || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</Col>
                                    </Row>
                                    <Col xs={12} className="border-bottom"></Col>
                                  </>
                                ))}
                                <Row>
                                    <Col></Col>
                                    <Col xs="auto" className="text-end">
                                      <div className="text-muted small border-dashed-top">
                                        total {parseFloat(grupo.saldo || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                                      </div>
                                    </Col>
                                  </Row>
                              </div>
                            ))}
                        <div className="border-dashed-top">
                              <Row>
                                <Col>Total em aberto</Col>
                                <Col xs="auto">
                                  <b>
                                    {parseFloat(extrato?.total_divida || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                                  </b>
                                </Col>
                              </Row>
                            </div>
                      </>
                </div>
          </div>
        </>
    );
};

const Contato = ({crud, Toast, empresa, queryParams}) => {
    const navigate = useNavigate();
    
    useEffect(() => {
      // Inicialize o AOS para as animações, caso esteja usando isso
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
        mirror: false
      });
    }, []);
    
    return (
        <>
          <div className="mt-3" data-aos="fade-up">
            <div>{empresa?.nome_da_loja}</div>
            WhatsApp {empresa?.telefone_whatsapp}
          </div>
        </>
    );
};

const PerfilCliente = ({crud, Toast, empresa, queryParams}) => {
    const navigate = useNavigate();
    const [cliente, setCliente] = useState(null);
    const { get } = crud;
    
    useEffect(() => {
      // Inicialize o AOS para as animações, caso esteja usando isso
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
        mirror: false
      });
    }, []);
    
    useEffect(()=>{
      const buscarCliente =async()=>{
        try{
          const response = await get(`/gvendas/clientes/?limit=1`);
          if(response && response.length){
            setCliente(response[0].results[0]);
          }
        }catch(err){
          //alert(JSON.stringify(err.response))
        }
      }
      buscarCliente();
    }, [setCliente])
    
    return (
        <>
          <div className="mt-3" data-aos="fade-up">
            <div>{cliente?.nome_do_cliente}</div>
            <div>{cliente?.telefone}</div>
          </div>
        </>
    );
};

const LoginCatalogo = ({crud, Toast, empresa, queryParams}) => {
    const navigate = useNavigate();
    const [login, setLogin] = useState(null);
    const [cliente, setCliente] = useState(null);
    const [telefone, setTelefone] = useState(null);
    const [tipo, setTipo]= useState('login');
    const { post, get, loading } =crud;
    const [formErrors, setFormErrors] = useState({});
    const { slug } = useParams();
    const {
      site
    } = useProvider();
    
    
    useEffect(() => {
      // Inicialize o AOS para as animações, caso esteja usando isso
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
        mirror: false
      });
    }, []);

    const validarErrosApi = (err) => {
        const errorMessage = typeof err.response?.data === 'string' 
            ? `Erro desconhecido. ${err.status}` 
            : err.response?.data?.detail;

        setFormErrors(prevErrors => ({
            ...prevErrors,
            apiError: errorMessage,
            email: err.response?.data?.non_field_errors?.length?'Email já está em uso':err.response?.data?.email,
            empresa: err.response?.data?.empresa?'Acesse com o app ou link da empresa':"",
            senha: err.response?.data?.senha,
        }));
    };


    
    const loginAuth =async()=>{
      const errors = {};
      setFormErrors({});
      if(!login?.email) errors.email="Informe o email de acesso";
      if(!login?.senha) errors.senha="Informe a senha de acesso";
        
      if (Object.keys(errors).length > 0) {
        setFormErrors(errors);
        return;
      }
      try{
        const response = await post({
          'email':login?.email,
          'senha':login?.senha,
          'empresa':empresa?.id
        },`/api-auth-cliente/token/`);
        if(response){
          // await storage.remover('clienteToken');
          // await storage.adicionar('clienteToken', {
          //  "token":response[0].token,
          //  "empresa":empresa?.url,
          //});
          window.location.reload();
        }
      }catch(err){
        validarErrosApi(err);
      }
    }
    
    const loginAuthCreate =async()=>{
      const errors = {};
      if(!cliente?.email) errors.email="Informe o email de acesso";
      if(!cliente?.senha) errors.email="Informe a senha de acesso";
      if(cliente?.senha !== cliente?.confirma_senha) errors.confirma_senha="As senhas não coincidem";
      if(!cliente?.id){
        if(!cliente?.nome_do_cliente) errors.email="Informe seu nome";
        if(!telefone) errors.email="Informe seu telefone WhatsApp";
        if(!cliente?.endereco) errors.email="Informe o endereço";
      }
        
      if (Object.keys(errors).length > 0) {
        setFormErrors(errors);
        return;
      }
      try{
        const clienteData = {
          'cliente':cliente?.id,
          'nome_do_cliente':cliente?.nome_do_cliente,
          'telefone':telefone||``,
          'endereco':cliente?.endereco||``,
          'email':cliente?.email,
          'senha':cliente?.senha,
          'empresa':empresa?.id
        }
        setFormErrors({});
        const formData = new FormData();
        formData.append('cliente', cliente?.id);
        formData.append('nome_do_cliente', cliente?.nome_do_cliente);
        formData.append('telefone', telefone);
        formData.append('endereco', cliente?.endereco);
        formData.append('email', cliente?.email);
        formData.append('senha', cliente?.senha);
        formData.append('token', cliente?.token);
        formData.append('empresa', empresa?.id);
        
        const response = await post(
          formData,
          `/api-auth-cliente/create/`
        );
        //alert(JSON.stringify(response))
        if(response){
          Toast.fire({
            icon: "success",
            title: "Acesso criado com sucesso"
          });
          setCliente(null);
          setTipo('login');
        }
      }catch(err){
        //alert(JSON.stringify(err.response));
        //alert(JSON.stringify(err.response?.data));
        //alert(JSON.stringify(err.response?.data?.non_field_errors));
        validarErrosApi(err);
      }
    }
    
    const buscarEnderecoGPS = async () => {
      try {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            async (position) => {
              const { latitude, longitude } = position.coords;

              // Substitua por sua chave de API do Google
              const apiKey = 'AIzaSyAg-c1FKLHKp4mWCvI_t8POfLXWQtQbix0';

              // URL da API
              const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`;

              // Fazendo a requisição usando fetch
              const response = await fetch(url);
              const data = await response.json();

              if (data.results && data.results.length > 0) {
                const addressComponents = data.results[0].address_components;

                const street = addressComponents.find(component => component.types.includes("route"))?.long_name || '';
                const number = addressComponents.find(component => component.types.includes("street_number"))?.long_name || '';

                // Tentando encontrar o bairro
                const neighborhood = addressComponents.find(component => component.types.includes("sublocality_level_1"))?.long_name ||
                                     addressComponents.find(component => component.types.includes("sublocality"))?.long_name ||
                                     addressComponents.find(component => component.types.includes("political"))?.long_name ||
                                     '';
                const cidade = addressComponents.find(component => component.types.includes("administrative_area_level_2"))?.long_name ||
                                     addressComponents.find(component => component.types.includes("political"))?.long_name ||
                                     '';
                const estadoUf = addressComponents.find(component => component.types.includes("administrative_area_level_1"))?.short_name ||
                                     addressComponents.find(component => component.types.includes("political"))?.short_name ||
                                     '';

                setCliente((prevItem) => ({
                    ...prevItem,
                    endereco: `${street}, n ${number}, ${neighborhood} - ${cidade}`,
                    regiao: `${neighborhood} - ${cidade}`,
                    uf: estadoUf,
                    cidade: cidade
                }));
              }
            },
            (error) => {
              console.error(error);
            }
          );
        }
      } catch (err) {
        console.error('Erro ao buscar endereço:', err);
      }
    };
    
    useEffect(()=>{
      if(tipo==="registrar"){
        buscarEnderecoGPS();
      }
    }, [tipo])
    
    useEffect(()=>{
      const comprovanteToken = async ()=>{
        const token=queryParams.get('t')?.toLowerCase();
        const id=queryParams.get('i')?.toLowerCase();
        //alert(empresa?.url||slug)
        if(id){
          return {
            token:token,
            id:id,
            empresa:empresa?.url||slug
          }
        }
        
        const response = {} // await storage.buscar('comprovante');
        //alert(JSON.stringify(response))
        if(response && response.length){
          return response[0];
        }
      }
      const buscarComprovante = async()=>{
        try{
          const {id, token, empresa} = await comprovanteToken();
          if (!id || !token || !empresa) return;
          const url = `/gvendas/vendas/${id}/${token}/${empresa}/?expand=cliente`;
          //alert(url);
          const response = await get(url,`comprovante`);
          if(response && response.length){
            //alert(JSON.stringify(response[0].cliente))
            setCliente(response[0].cliente);
          }
        }catch(err){

        }
      }
      buscarComprovante();
    }, [setCliente])

    return (
        <>
          <div className="mt-3" data-aos="fade-up">
            <Col xs={6} md={3} className="mx-auto">
              <ImageCropper so_exibe={true} foto={`https://${site?.domain}${site?.favicon}`} radius={2} width={512} height={512} className="col-12 col-md-6 mx-auto text-center"/>
            </Col>
            {tipo==='login' && (<>
              <Col data-aos="fade-up">
                <div className="fs-4 py-2 text-center">Área do Cliente</div>
                <div className="text-center text-muted">Área restrida de clientes de {empresa?.nome_da_loja}</div>
                {formErrors.apiError && <Alert variant="danger">{formErrors.apiError}</Alert>}
                {formErrors.empresa && <Alert variant="danger">{formErrors.empresa}</Alert>}
                <Form.Group controlId="formEmail" className="mt-3">
                  <InputGroup>
                    <span className="input-group-text">Email</span>
                    <Form.Control 
                      type="email" 
                      placeholder="Informe seu email de acesso"
                      onChange={(e) => setLogin((prevItem) => {
                        return {
                          ...prevItem,
                          email: e.target.value
                        };
                      })}
                    />
                  </InputGroup>
                  {formErrors.email && <Alert variant="danger">{formErrors.email}</Alert>}
                </Form.Group>
                <Form.Group controlId="formSenha" className="mt-3">
                  <InputGroup>
                    <span className="input-group-text">Senha</span>
                    <Form.Control 
                      type="password" 
                      placeholder="Informe sua senha de acesso"
                      onChange={(e) => setLogin((prevItem) => {
                        return {
                          ...prevItem,
                          senha: e.target.value
                        };
                      })}
                    />
                  </InputGroup>
                  {formErrors.senha && <Alert variant="danger">{formErrors.senha}</Alert>}
                </Form.Group>
                <Button 
                    variant="secondary" 
                    disabled={!login?.email || !login?.senha || loading} 
                    className="w-100 mt-4"
                    onClick={loginAuth}
                  >
                    Acessar
                </Button>
                <Button 
                    variant="outline-secondary" 
                    className="w-100 btn-sm mt-4"
                    onClick={()=>setTipo('registrar')}
                  >
                    Criar acesso
                </Button>
              </Col>
            </>)}
            {tipo==='registrar' && (<>
              <Col data-aos="fade-up">
                <div className="fs-4 py-2 text-center">Criar acesso</div>
                <div className="text-center text-muted">Área restrida de clientes de {empresa?.nome_da_loja}</div>
                {formErrors.apiError && <Alert variant="danger">{formErrors.apiError}</Alert>}
                {formErrors.empresa && <Alert variant="danger">{formErrors.empresa}</Alert>}
                {cliente?.id && (
                  <div className="fs-5 py-2">{cliente?.nome_do_cliente} {cliente?.telefone}</div>
                )}
                {!cliente?.id && (
                  <>
                    <Form.Group controlId="formNome" className="mt-3">
                      <InputGroup>
                        <span className="input-group-text">Nome</span>
                        <Form.Control 
                          type="text" 
                          placeholder="Nome Completo"
                          onChange={(e) => setCliente((prevItem) => {
                            return {
                              ...prevItem,
                              nome_do_cliente: e.target.value
                            };
                          })}
                        />
                      </InputGroup>
                      {formErrors.nome_do_cliente && <Alert variant="danger">{formErrors.nome_do_cliente}</Alert>}
                    </Form.Group>
                    
                    <PhoneInput phone={telefone} setPhone={setTelefone} formErrors={formErrors} is_obrigatorio={true} label={"WhatsApp"}/>
                    {formErrors.telefone && <Alert variant="danger">{formErrors.telefone}</Alert>}
  
                    <Form.Group controlId="formEndereco" className="mt-3">
                      <InputGroup>
                        <span className="input-group-text">Endereço</span>
                        <Form.Control 
                          type="text"
                          value={cliente?.endereco}
                          placeholder="Nome da rua, n° - bairro, Cidade"
                          onChange={(e) => setCliente((prevItem) => {
                            return {
                              ...prevItem,
                              endereco: e.target.value
                            };
                          })}
                        />
                      </InputGroup>
                    </Form.Group>
                    {formErrors.endereco && <Alert variant="danger">{formErrors.endereco}</Alert>}
                  </>
                )}
                <Form.Group controlId="formEmail" className="mt-3">
                  <InputGroup>
                    <span className="input-group-text">Email</span>
                    <Form.Control 
                      type="email" 
                      placeholder="Informe seu email de acesso"
                      onChange={(e) => setCliente((prevItem) => {
                        return {
                          ...prevItem,
                          email: e.target.value
                        };
                      })}
                    />
                  </InputGroup>
                  {formErrors.email && <Alert variant="danger">{formErrors.email}</Alert>}
                </Form.Group>
                <Form.Group controlId="formSenha" className="mt-3">
                  <InputGroup>
                    <span className="input-group-text">Senha</span>
                    <Form.Control 
                      type="password" 
                      placeholder="Informe sua senha de acesso"
                      onChange={(e) => setCliente((prevItem) => {
                        return {
                          ...prevItem,
                          senha: e.target.value
                        };
                      })}
                    />
                  </InputGroup>
                  {formErrors.senha && <Alert variant="danger">{formErrors.senha}</Alert>}
                </Form.Group>
                <Form.Group controlId="formSenha" className="mt-3">
                  <InputGroup>
                    <span className="input-group-text">Confirmar</span>
                    <Form.Control 
                      type="password" 
                      placeholder="Confirmar senha de acesso"
                      onChange={(e) => setCliente((prevItem) => {
                        return {
                          ...prevItem,
                          confirma_senha: e.target.value
                        };
                      })}
                    />
                  </InputGroup>
                  {formErrors.confirma_senha && <Alert variant="danger">{formErrors.confirma_senha}</Alert>}
                </Form.Group>
              </Col>
              <Button 
                  data-aos="fade-up"
                  variant="secondary" 
                  disabled={loading} 
                  className="w-100 mt-4"
                  onClick={loginAuthCreate}
                >
                  Criar acesso
              </Button>
                <Button 
                    data-aos="fade-up"
                    variant="outline-secondary" 
                    className="w-100 btn-sm mt-4"
                    onClick={()=>setTipo('login')}
                  >
                    Ir para login
                </Button>
            </>)}
          </div>
        </>
    );
};

const Comprovante = ({crud, Toast, empresa, queryParams}) => {
    const navigate = useNavigate();
    const { slug } = useParams();
    const [venda, setVenda] = useState(null);
    const [meuLink, setMeuLink] = useState();
    const { get } = crud;
    const {
      catalogo,
      site
    } = useProvider();
    
    
    useEffect(() => {
      // Inicialize o AOS para as animações, caso esteja usando isso
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
        mirror: false
      });
    }, []);
    
    useEffect(()=>{
      const comprovanteToken = async ()=>{
        const token=queryParams.get('t')?.toLowerCase();
        const id=queryParams.get('i')?.toLowerCase();
        //alert(`comprovanteToken\n${JSON.stringify(empresa)}`)
        //alert(`comprovanteToken\n${empresa?.url||slug}`)
        if(id){
          return {
            token:token,
            id:id,
            empresa:empresa?.url||slug
          }
        }
        
        const response = {} // await storage.buscar('comprovante');
        //alert(`response\n${JSON.stringify(response[0])}`)
        if(response && response.length){
          const result = {
            ...response[0],
            id:id || response[0].id,
            //empresa:empresa?.url||slug||response[0].empresa
          }
          //alert(`result\n${JSON.stringify(result)}`)
          if(id){
            // await storage.remover('comprovante');
            // await storage.adicionar('comprovante', result);
          }
          
          return result;
        }
      }
      const buscarComprovante = async()=>{
        try{
          const {id, token, empresa} = await comprovanteToken();
          if (!id || !token || !empresa) return;
          const url = `/gvendas/vendas/${id}/${token}/${empresa}/?expand=cliente,venda_itensvenda,produto,venda_pagamentos`;
          //alert(url);
          const response = await get(url,`comprovante`);
          if(response && response.length){
            setVenda(response[0]);
          }
        }catch(err){

        }
      }
      if(empresa) buscarComprovante();
      setMeuLink(localStorage.getItem("hash_token"));
    }, [empresa])
      
    const topoContent = () => {
      return (
        <>
          <Row className="align-items-center">
            <Col className="text-end">
              <div className="fs-3">{empresa?.nome_da_loja}</div>
              <div className="text-muted small">
                <ReactMarkdown>
                  {empresa?.descricao} 
                </ReactMarkdown> 
              </div>
            </Col>
            <Col xs="auto">
              <RenderizarFoto src={`https://${site?.domain}${empresa?.logomarca}`} alt="" />
            </Col>
          </Row>
        </>
      );
    };
    const clienteContent = () => {
      //const vtotal = pagamentosAberto.reduce((acc, linha) => acc + parseFloat(linha.valor_total || 0), 0);
      const dataAtual = new Date();
      const dia = String(dataAtual.getDate()).padStart(2, '0');
      const mes = String(dataAtual.getMonth() + 1).padStart(2, '0'); // Janeiro é 0
      const ano = dataAtual.getFullYear();
      
      const horas = String(dataAtual.getHours()).padStart(2, '0');
      const minutos = String(dataAtual.getMinutes()).padStart(2, '0');
      
      const opcoes = { timeZoneName: 'short' };
      const fusoHorario = dataAtual.toLocaleTimeString('pt-BR', opcoes).split(' ')[2];
      
      const dataFormatada = `${dia}/${mes}/${ano} às ${horas}:${minutos}`;
      
      return (
        <>
          <Row className="align-items-center">
            <Col>
              <div className="">Data da compra: {venda?.data_da_venda}</div>
              <div className="">Cliente: {venda?.cliente?.nome_do_cliente?.trimStart().split(' ')[0]}</div>
              <div className="text-muted small">
                <>
                    <Row>
                      <Col>Pago</Col>
                      <Col xs="auto">Total da compra</Col>
                    </Row>
                    <BarraDeProgresso valor={venda?.total_pago} total={venda?.total} variant="secondary"/>
                    <Row>
                      <Col>
                        {parseFloat(venda?.total_pago||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                      </Col>
                      <Col xs="auto">
                        {parseFloat(venda?.total||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} 
                      </Col>
                    </Row>
                  </>
                <>
                    Em aberto desta compra: {parseFloat(venda?.total_aberto||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} 
                  </>
                <div>
                  <i>Gerado em {dataFormatada}</i>
                </div>
              </div>
            </Col>
          </Row>
        </>
      );
    };
    const itensContent = () => {
      return (
        <>
          <div className="border-dashed-bottom mb-2">Itens</div>
          {venda?.venda_itensvenda?.map((item, index) => (
            <>
              <Row>
                <Col>
                  {item.quantidade}x {item.produto.nome_do_produto}
                </Col>
                <Col xs="auto" className="text-end">{parseFloat(item.preco_unitario || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</Col>
              </Row>
              <Col xs={12} className="border-bottom"></Col>
            </>
          ))}
        </>
      );
    };
    const parseData = (data) => {
        if (!data) return '';
        
        if (data.includes('-')) { // Usa includes() em vez de contains()
            const [ano, mes, dia] = data.split('-');
            return `${dia}/${mes}/${ano}`;
        }
    
        const [dia, mes, ano] = data.split('/');
        return `${ano}-${mes}-${dia}`;
      }
    const pagamentosContent = () => {
      const lista = venda?.venda_pagamentos?.sort((a, b) => new Date(parseData(a.data_do_pagamento)) - new Date(parseData(b.data_do_pagamento)));
      return (
        <>
          <div className="border-dashed-bottom mb-2">Forma de Pagamento</div>
          {lista?.map((item, index) => (
            <>
              <Row>
                <Col>
                  {parseFloat(item.total_de_juros_e_multa || 0)>0 && (<><s className="small">{item.data_do_vencimento}</s>{` `}</>)}
                  {item.data_do_pagamento}
                </Col>
                <Col xs="auto" className="text-end">
                  {parseFloat(item.total_de_juros_e_multa||0)>0 ? (
                    <>
                      <i className="bx bi-info"></i>
                      <s className="small">
                        {parseFloat(item.valor || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                      </s>{` `}
                      {item.pago && (<i className="bx bx-check-circle"></i>)} 
                      {parseFloat(item.valor_total || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                    </>
                  ):(
                    <>
                      {item.pago && (<i className="bx bx-check-circle"></i>)} 
                      {parseFloat(item.valor || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                    </>
                  )} 
                </Col>
              </Row>
              <Col xs={12} className="border-bottom"></Col>
            </>
          ))}
        </>
      );
    };
    const vendaContent = () => {
      return (
        <>
          <div className="border-dashed-bottom mb-2"></div>
          {parseFloat(venda?.desconto ||0) >0 && (
            <>
              <Row>
                <Col>
                  Total sem desconto
                </Col>
                <Col xs="auto" className="text-end">
                  {parseFloat(venda?.sub_total || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                </Col>
              </Row>
              <Col xs={12} className="border-bottom"></Col>
              <Row>
                <Col>
                  Desconto
                </Col>
                <Col xs="auto" className="text-end">
                  {parseFloat(venda?.desconto || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                </Col>
              </Row>
              <Col xs={12} className="border-bottom"></Col>
            </>
          )}
          {parseFloat(venda?.juros_multa ||0) >0 && (
            <>
              <Row>
                <Col>
                  Juros e multa
                </Col>
                <Col xs="auto" className="text-end">
                  {parseFloat(venda?.juros_multa || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                </Col>
              </Row>
              <Col xs={12} className="border-bottom"></Col>
            </>
          )}
          <Row className="mt-2">
            <Col>
              Total da compra
            </Col>
            <Col xs="auto" className="text-end">
              <b>
                {parseFloat(venda?.total || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
              </b>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              Total geral em aberto
            </Col>
            <Col xs="auto" className="text-end">
              <b>
                {parseFloat(venda?.cliente?.venda_total_aberto || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
              </b>
            </Col>
          </Row>
        </>
      );
    };
    const instrucoesContent = () => {
      return (
        <>
          <div className="border-dashed-bottom mb-2"></div>
          <ReactMarkdown
            children={empresa?.instrucoes}
            components={{
              p: ({ children }) => <p style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{children}</p>,
            }}
          />
        </>
      );
    };
    const empresaContent = () => {
      const anoAtual = new Date().getFullYear();
      const copyright = `© ${anoAtual} ${empresa?.nome_da_loja}`;
      return (
        <>
          <div className="text-center">
            <div className="fs-5">{empresa?.nome_da_loja}</div>
            <div className="text-center">
              {empresa?.agradecimento?(
                <>
                  <ReactMarkdown
                    className=""
                    children={empresa?.agradecimento}
                    components={{
                      p: ({ children }) => <p style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{children}</p>,
                    }}
                  />
                </>
              ):(
                <>Obrigado pela oportunidade em poder atender você! </>
              )}
            </div>
            <div className="small mt-3 text-muted">
              {copyright}
            </div>
          </div>
        </>
      );
    };
    

    return (
      <>
        <div className="d-flex justify-content-center mt-3">
          <div className="pb-5 pt-5 border rounded pe-4 ps-4" style={{ width: '450px' }}>
            <Row>
              <Col xs="auto" className="mx-auto">
                <InputGroup>
                  <Button variant="outline-secondary" onClick={()=>navigate(`${catalogo}?p=feedback`)}>Faça uma avaliação</Button>
                  {meuLink && (<>
                    <Button variant="outline-secondary" onClick={()=>navigate(`/p/${meuLink}/flex/`)}>Meus Débitos</Button>
                  </>)}
                </InputGroup>
              </Col>
            </Row>
            <div className="py-3">
              {topoContent()}
            </div>
            {venda && (<>
              <div className="py-1">
                {clienteContent()}
              </div>
              <>
                <div className="py-3">
                  {itensContent()}
                </div>
                <div className="py-3">
                  {pagamentosContent()}
                </div>
                <div className="py-4">
                  {vendaContent()}
                </div>
              </>
              {venda?.observacoes && (
                <div className="py-1 text-muted small">
                  <div className="small text-muted">
                    Observações:
                  </div>
                  <ReactMarkdown
                    className="p-2 border rounded"
                    children={venda?.observacoes}
                    components={{
                      p: ({ children }) => <p style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{children}</p>,
                    }}
                  />
                </div>
              )}

              {(venda?.juros_por_atraso || venda?.juros_multa > 0) && (
                <>
                  <div className="text-muted text-center small">
                     O atraso no pagamento serão cobrados juros {empresa?.juros?.juros_mensal}% ao mês e multa {empresa?.juros?.multa_percentual}% sobre o valor da parcela
                  </div>
                </>
              )}
              {(venda?.total_aberto > 0) && (
                <div className="py-1">
                  {instrucoesContent()}
                </div>
              )}
            </>)}
            <div className="pt-3 pb-5">
              {empresaContent()}
            </div>
          </div>
        </div>
      </>
    );
};


export default Catalogo;